import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function userDetailsReducer(state = initialState.userDetails, action){
    switch (action.type) {
    case types.USER_DETAILS_LOADED_SUCCESS:
        return action.userDetails;
    default:
        return state;
    }
}